import request from '@/utils/request'

export function getUserList(data) {
  return request({ url: '/admin/user/list', method: 'post', data })
}

export function createUser(data) {
  return request({ url: '/admin/user/create', method: 'post', data })
}

export function updateUser(data) {
  return request({ url: '/admin/user/update', method: 'post', data })
}

export function deleteUser(data) {
  return request({ url: '/admin/user/delete', method: 'post', data })
}

export function getUserDetail(data) {
  return request({ url: '/admin/user/detail', method: 'post', data })
}

export function assignUserRole(data) {
  return request({ url: '/admin/user/assignRole', method: 'post', data })
}
